import React, { FunctionComponent, useLayoutEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AccordionGroup, Card, isLargeDesktop } from 'rs-emd-ui-atoms';
import { TextWidget } from '../..';
import { getAttributes } from '../../../../helpers/html.utils';
import { IAllCategoriesWidget } from '../../../../models/campaign-pages/widgets/all-categories/all-categories.model';
import styles from './categories-list-component.module.scss';

export type CategoriesListProps = { categoriesList: IAllCategoriesWidget };

export const CategoriesList: FunctionComponent<CategoriesListProps> = (props: CategoriesListProps) => {
  let [isAccordionGroupOpenByDefault, setIsAccordionGroupOpenByDefault] = useState(getIsOpenByDefault());

  useLayoutEffect(() => {
    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };

    function onResize() {
      setIsAccordionGroupOpenByDefault(getIsOpenByDefault());
    }
  }, []);

  let accordions = props.categoriesList.categories.map((category, i) => {
    return {
      title: (
        <p>
          {category.url.text} ({category.noOfProducts})
        </p>
      ),
      className: styles.accordion,
      isHeaderFixed: false,
      headingClassName: styles['category-heading'],
      headerId: `all-cat-${category.id}`,
      isOpenByDefault: isAccordionGroupOpenByDefault,
      children: (
        <div className={styles['sub-categories-container']}>
          {category.childCategories.map((subCategory) => {
            return (
              <div id={`child-cat-${subCategory.id}`} className={styles['sub-category']}>
                <Link to={subCategory.url.url} {...getAttributes(subCategory.url.attributes)}>
                  {subCategory.url.text} ({subCategory.noOfProducts})
                </Link>
              </div>
            );
          })}
        </div>
      ),
    };
  });

  return (
    <Card className={styles['categories-list-container']} radius={'8px'}>
      <div className={styles.title}>
        <TextWidget
          textWidget={{
            textData: [{ ...props.categoriesList.title, textSize: props.categoriesList.title.textSize ?? 'sm' }],
          }}></TextWidget>
      </div>
      <AccordionGroup groupName={'categories-list'} accordions={accordions} />
    </Card>
  );

  function getIsOpenByDefault() {
    if (isLargeDesktop() /*|| is XLargeDesktop()*/) {
      return true;
    } else {
      return false;
    }
  }
};

export default CategoriesList;
